import { Logo1Dark, Logo1White } from '@blocksuite-local/icons/auto/24/rc';
import { useLiveData, useService } from '@toeverything/infra';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

import { AppSidebarService } from '../../services/app-sidebar';
import { navHeaderStyle } from '../index.css';
import * as styles from './sidebar-header.css';
import { SidebarSwitch } from './sidebar-switch';

const SidebarLogo = () => {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  if (!mounted) {
    return <div className={styles.logoPlaceholder} />;
  }

  return resolvedTheme === 'dark' ? (
    <Logo1White className={styles.logo} />
  ) : (
    <Logo1Dark className={styles.logo} />
  );
};

export const SidebarHeader = () => {
  const appSidebarService = useService(AppSidebarService).sidebar;
  const open = useLiveData(appSidebarService.open$);

  return (
    <div className={navHeaderStyle} data-open={open}>
      <SidebarLogo />
      <SidebarSwitch show={open} />
    </div>
  );
};

export * from './sidebar-switch';
